import React, { useState, useEffect } from "react";
import { Typography, Icon } from "@ann/web-components";
import {
  CardContainer,
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
  TitleContainer,
  CardContent,
  IconWrapper,
  ChevronWrapper,
} from "./ExpandableContentCard.styled";

const ExpandableContentCard = ({ 
  title, 
  subtitle,
  children, 
  defaultExpanded = false,
  isExpanded: controlledExpanded,
  onToggle,
}) => {
  const isControlled = controlledExpanded !== undefined;
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
  
  // Sync internal state with controlled prop
  useEffect(() => {
    if (isControlled) {
      setInternalExpanded(controlledExpanded);
    }
  }, [isControlled, controlledExpanded]);

  const isExpanded = isControlled ? controlledExpanded : internalExpanded;

  const handleToggle = () => {
    if (isControlled && onToggle) {
      onToggle();
    } else {
      setInternalExpanded((prev) => !prev);
    }
  };

  return (
    <CardContainer>
      <CardHeader onClick={handleToggle} $isExpanded={isExpanded}>
        <CardHeaderLeft>
          <div>
            <Icon name="person" size="small" color="primary-alt" />
          </div>  
          <TitleContainer>
            <Typography category="subtitle" size="small" weight="bold">
              {title}
            </Typography>
            {subtitle && (
              <Typography category="body" size="medium" weight="regular" color="body">
                {subtitle}
              </Typography>
            )}
          </TitleContainer>
        </CardHeaderLeft>
        <CardHeaderRight>  
          <ChevronWrapper $isExpanded={isExpanded}>
            <Icon name="chevronDown" size="medium" />
          </ChevronWrapper>
        </CardHeaderRight>
      </CardHeader>
      {children && (
        <CardContent $isExpanded={isExpanded}>
          {children}
        </CardContent>
      )}
    </CardContainer>
  );
};

export default ExpandableContentCard;
